/* esm.sh - applesauce-loaders@5.1.0/dist/operators/generator */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/operators/generator.mjs";
